<template>
  <p ref="text" class="wander-text">
    <span
      v-for="(letter, i) in 'wander'"
      name="letter"
      :class="letterClasses(letter)"
      :key="i">
      {{letter}}
    </span>
  </p>
</template>

<script>
export default{
  name: 'wander-text',
  props: {
    xDisplace: {
      type: Number,
      default: 50
    },
    yDisplace: {
      type: Number,
      default: 20
    }
  },
  methods: {
    init() {
      this.root = this.$refs.text
      this.animating = false
      this.letters = this.root.querySelectorAll('[name=letter]')
      requestAnimationFrame(() => this.moveLetters())
      this.initialized = true
    },
    letterClasses(letter) {
      return `letter ${letter.toUpperCase()}`
    },
    getX(i, total) {
      const half = (total - 1)/2
      const random = 1 - Math.random() * 0.5
      const distance = (this.xDisplace / half) * (half - i)
      return distance * random * -1
    },
    getY(i) {
      const random = 1 - Math.random() * 0.9
      const distance = this.yDisplace * random
      return (i % 2 === 0) ? distance : distance * -1
    },
    moveLetters() {
      const letters = this.root.querySelectorAll('[name=letter]')
      for (let i = 0; i < letters.length; i++) {
        const l = letters[i]
        const x = Math.round(this.getX(i, letters.length)) + 'px'
        const y = Math.round(this.getY(i)) + 'px'
        const transform = `translate(${x}, ${y})`
        this.addTransform(l, transform)
      }
    },
    addTransform(el, transform) {
      if (el.style.transform == 'none') {
        el.style.transform = ''
      }
      el.style.transform += transform
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped lang="scss">
/** wander-text **/
@import '../../theme';

.wander-text {
  @include zespri-heading;
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  // Rotate helps resolve animation rendering issues in Firefox.
  transform: scale(0.5) rotate(0.01deg);
  transform-origin: top left;

  color: $white;
  text-shadow: 2px -2px 153px rgba(39, 30, 13, 0.25);

  @include media-breakpoint-up(md) {
    // Rotate helps resolve animation rendering issues in Firefox.
    transform: scale(1) rotate(0.01deg);
  }
}

.letter {
  display: block;
  transition: transform 10s ease-in-out;
}

.D {
  &:before {
    content: '';
    //force a git change
    background-image: url('../../assets/home/d-beetle.png');
    width: 44px;
    height: 52px;
    position: absolute;
    bottom: 40px;
    right: 10px;
  }
}

</style>
